import { cn } from '@/lib';
import { TAX_BEHAVIOUR } from '@/lib/constants';

const TAX_IMAGES = {
    INCLUSIVE: '/images/taxes/inclusive.svg',
    EXCLUSIVE: '/images/taxes/exclusive.svg',
} as const;

interface TaxBehaviorSelectorProps {
    behavior: 'inclusive' | 'exclusive';
    loading: boolean;
    onBehaviorChange: (behavior: 'inclusive' | 'exclusive') => void;
}

export const TaxBehaviorSelector = ({ behavior, loading, onBehaviorChange }: TaxBehaviorSelectorProps) => (
    <div>
        <div className='mb-4'>
            <div className='text-label-sm-bold mb-1'>Tax Settings</div>
            <p className='text-caption-2-regular text-gray'>This example shows a $20 priced product.</p>
        </div>
        <div className='grid max-w-lg grid-cols-2 gap-4'>
            <TaxBehaviorOption
                label='Inclusive'
                imageSrc={TAX_IMAGES.INCLUSIVE}
                isSelected={behavior === TAX_BEHAVIOUR.INCLUSIVE}
                disabled={loading}
                onSelect={() => onBehaviorChange(TAX_BEHAVIOUR.INCLUSIVE as 'inclusive')}
            />
            <TaxBehaviorOption
                label='Exclusive'
                imageSrc={TAX_IMAGES.EXCLUSIVE}
                isSelected={behavior === TAX_BEHAVIOUR.EXCLUSIVE}
                disabled={loading}
                onSelect={() => onBehaviorChange(TAX_BEHAVIOUR.EXCLUSIVE as 'exclusive')}
            />
        </div>
    </div>
);

interface TaxBehaviorOptionProps {
    label: string;
    imageSrc: string;
    isSelected: boolean;
    disabled: boolean;
    onSelect: () => void;
}

const TaxBehaviorOption = ({ label, imageSrc, isSelected, disabled, onSelect }: TaxBehaviorOptionProps) => (
    <div className='max-w-[250px] cursor-pointer' onClick={() => !disabled && onSelect()}>
        <div className='mb-2 flex items-center gap-2'>
            <input type='radio' name='taxBehavior' checked={isSelected} readOnly className='accent-brand-main' />
            <span className='text-caption-2-regular text-gray'>{label}</span>
        </div>
        <div
            className={cn(
                'rounded-lg border transition-colors',
                isSelected ? 'border-brand-main' : 'border-neutral-disabled'
            )}
        >
            <img src={imageSrc} alt={`${label} tax`} className='w-full rounded-lg' />
        </div>
    </div>
);
